import React from "react";
import styled from "styled-components";
import { WeeklyLeaderboardItem } from "../../types";
import LeaderboardPhoto from "../../../components/LeaderboardPhoto";
import { colors, fonts } from "../../../constants";
import CoinText from "./CoinText";

const Main = styled.div`
    display: flex;
    justify-content: space-around;
    font-size: ${fonts.subtitle}px;
    font-weight: 500;
`;

const Item = styled.div`
    width: 90px;
    cursor: pointer;
`;

const PhotoContainer = styled.div`
    height: 114px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 5px;
    justify-content: flex-end;
`;

const Title = styled.div`
    margin-top: 4px;
`;

const Bonus = styled.div`
    font-size: 12px;
    font-weight: normal;
    margin-top: 8px;
    color: ${colors.secondaryGray};
`;

interface Props {
    weeklyLeaderboard: WeeklyLeaderboardItem[];
    onSelect?: (publisher: WeeklyLeaderboardItem) => void;
}

const WeeklyTopThree = ({ weeklyLeaderboard, onSelect }: Props) => {
    const [first, second, third] = weeklyLeaderboard;
    const rows = [
        { item: first, place: 1, label: "1st Place" },
        { item: second, place: 2, label: "2nd Place" },
        { item: third, place: 3, label: "3rd Place" }
    ];

    return (
        <Main>
            {rows.map(({ item, place, label }, i) => {
                if (!item) return null;
                return (
                    <Item
                        key={i}
                        onClick={() => {
                            onSelect && onSelect(item);
                        }}
                    >
                        <PhotoContainer>
                            <LeaderboardPhoto
                                profilePhotoUrl={item.profilePhotoUrl}
                                place={place}
                                type={item.type}
                            />
                        </PhotoContainer>
                        <Title>{label}</Title>
                        <CoinText amount={item.earnings} />
                        <Bonus>{item.bonusPercentage}% bonus</Bonus>
                    </Item>
                );
            })}
        </Main>
    );
};

export default WeeklyTopThree;
